import { create } from "sheetly";
export let text = ".factor-table{overflow:auto}td,th{padding:.25em!important}";
export const sheet = create(text, import.meta.url);
